import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Inputs from "../../components/inputs/Inputs";
import itemsList from "../../assets/JsonData/items-list.json";
import { toast } from "react-toastify";
import moment from "moment";
import MyDialog from "../../components/dialog/Dialog";
import MySpinner from "../../components/Spinner/spinner";
import Detaildialog from "../../components/dialog/Detaildialog";
import { getSales, reverseSale, saleInvoice } from "../../app/salesSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { instCat } from "../../common/validators";

const nowDate =  new Date();
const _fromDate =  new Date();
//const startDate = moment(_fromDate.setDate(1)).format("YYYY-MM-DD")

const salesTableHead = instCat() === 4 ?
 
[
  { label: "Date", name: "selling_date" },
  { label: "Item Code", name: "item_code" },
  { label: "Description", name: "item_description" },
  { label: "Amount", name: "amount" },
  { label: "Type", name: "deposit_withdraw" },
  { label: "Customer", name: "customer_name" },
  { label: "Reference", name: "tran_ref" },  
  { label: "Invoice No", name: "invoice_no" },
  "action",
]
:
[
  { label: "Date", name: "selling_date" },
  { label: "Item Code", name: "item_code" },
  { label: "Description", name: "item_description" },
  { label: "Customer", name: "customer_name" },
  { label: "Quantity", name: "qty" },
  // { label: "Package", name: "package" },
  { label: "Rate", name: "rate" },  
  { label: "Amount", name: "amount" },
  { label: "Stock Rate", name: "stocking_price_rate" },
  { label: "Profit", name: "profit_amount" },
  // { label: "Per", name: "unit_name" },
  { label: "Reference", name: "invoice_no" },
  "action",
];


const Sales = () => {
  let [openForm, setOpenForm] = useState(false);
  let [openDetail, setOpenDetail] = useState(false);
  let [reverse, setReverse] = useState(false);
  let [hideSaveButton, setHideSaveButton] = useState(false);
  const [formValues, setFormValues] = useState({fromDate: moment(_fromDate.setDate(1)).format("YYYY-MM-DD"), toDate: moment(nowDate).format("YYYY-MM-DD")});
  const [selectedItem, setSelectedItem] = useState({});
  const [salesDataList, setSalesDataList] = useState([]);
  const [errors, setErrors] = useState([]);

  const tableHead = [
    { label: "Item Name", name: "item_description" },
    { label: "Item Code", name: "item_code" },
    { label: "Amount", name: "amount" },
    { label: "Package", name: "package" },
    { label: "Quantity", name: "qty" }
  ];

  const dispatch = useDispatch();

  const { error, status, list } = useSelector(
    ({ sales }) => sales.get
  );

  const { error:putError, status: putStatus, data: putData } = useSelector(
    ({ sales }) => sales.put
  );

  const { error:invoiceError, status:invoiceStatus, data } = useSelector(
    ({ sales }) => sales.invoice
  );

  
  
  useEffect(() => {
    dispatch(getSales(formValues));     
  }, [dispatch]);

  useEffect(() => {
   if(invoiceStatus == 'idle' && data){
    setOpenDetail(true)
   }    
  }, [invoiceStatus,data]);

  
  useEffect(() => {
    if(!putError && putStatus == 'idle' && putData){
     
    }  
    setHideSaveButton(false)  
   }, [putData,putStatus,putError]);

   useEffect(()=>{
    if(formValues.fromDate && formValues.toDate){
      loadSalesDataFilter()
    }
   },[formValues])

  useEffect(() => {
    
    if(list && list.length > 0){   
      let newList = [];
      for (let index = 0; index < list.length; index++) {
        let newObj = {
          ...list[index],
          selling_date:moment(list[index]?.selling_date).format("YYYY-MM-DD"),
          profit_amount: Number(list[index].amount - ((list[index]?.stocking_price_rate ?? 0) * list[index].qty ?? 0)).toLocaleString(),
          amount: Number(list[index].amount ?? 0).toLocaleString(),
          stocking_price_rate: Number(list[index].stocking_price_rate ?? 0).toLocaleString(),
          rate: Number(list[index].rate ?? 0).toLocaleString(),
          qty: Number(list[index].qty ?? 0).toLocaleString(),
          package: list[index].package ? list[index].package : list[index].unit_name
        }
        newList.push(newObj)    
        //console.log('newObj',newObj)   
      }
      setSalesDataList(newList);
    }else {
      setSalesDataList([])
    }   
  }, [list]);

  const handleRequestClose = () => {
    setOpenDetail(false)
    setOpenForm(false)
  };

  const thermalPrinting = () => {

  }

  const dialogOpen = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <span>Invoice Number</span>&nbsp;&nbsp;
            <span><b>{data?.saleHeader?.invoice_no}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Amount</span>&nbsp;&nbsp;
            <span><b>{Number(data?.saleHeader?.amount).toLocaleString()}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Date</span>&nbsp;&nbsp;
            <span><b>{moment(data?.saleHeader?.date).format("YYYY-MM-DD")}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Items</span>&nbsp;&nbsp;
            <span><b>{data?.saleHeader?.items}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Customer</span>&nbsp;&nbsp;
            <span><b>{data?.saleHeader?.customer}</b></span>
          </div>
          <br /> <br />
          <div className="col-sm-12 col-md-12 col-12">
          </div>
          <br /> <br />
          <div className="col-12">
            {data?.saleDetails.length > 0 ? (
              <Table
                columns={tableHead}
                data={data?.saleDetails}
                downloadFileName={"Sale Receipt"}
              />
            ) : 
            (
              <MySpinner size={35} color="#367588" />
            )}
          </div>

        </div>
      </>
    );
  };

  const reverseDialogOpen = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <span>Invoice No</span>&nbsp;&nbsp;
            <span><b>{formValues?.invoice_no}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Amount</span>&nbsp;&nbsp;
            <span><b>{Number(formValues?.amount).toLocaleString()}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Date</span>&nbsp;&nbsp;
            <span><b>{moment(formValues?.date).format("YYYY-MM-DD")}</b></span>
          </div>
          <div className="col-sm-12 col-md-6 col-6">
            <span>Item</span>&nbsp;&nbsp;
            <span><b>{formValues?.item_description} ({formValues?.item_code})</b></span>
          </div>
          <br /> <br />
          <div className="col-sm-12 col-md-12 col-12">
          </div>
          <br /> <br />

        </div>
      </>
    );
  };

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    var newFormValues = {...formValues,is_reverse: 1}
    setFormValues(newFormValues)
    //alert(JSON.stringify(formValues))
    //toast.success(JSON.stringify(formValues));
    setHideSaveButton(true)
    dispatch(reverseSale(formValues))
     
    
  };

  const viewItem = (item) => {
    //alert(JSON.stringify(item))
    dispatch(saleInvoice({invoice_no:item?.invoice_no}))
  }

  const handleReverse = (item) => {
    //alert(JSON.stringify(item))
    setOpenForm(true);
    setFormValues(item);
    setReverse(true);
    //dispatch(saleInvoice({invoice_no:item?.invoice_no}))
  }

 
  const isDetailsAccess = () => {
    return instCat() === 4 ? false : true;
  }

  const loadSalesDataFilter = () => {
    let startDate = new Date();
    let endDate = new Date();
    startDate = moment(startDate).format("YYYY-MM-DD")
    startDate = formValues && formValues.fromDate ? moment(formValues.fromDate).format("YYYY-MM-DD") : startDate;
    endDate = formValues && formValues.toDate ? moment(formValues.toDate).format("YYYY-MM-DD") : startDate;
    dispatch(getSales({fromDate:startDate, toDate: endDate}));
  }

  const handleSearchSales = () => {
    loadSalesDataFilter()
  }

  const formOpenSalesSearch = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-4">
            <Inputs
              name="fromDate"
              size="small"
              label="Start Date"
              value={formValues.fromDate}
              inputType="date"
              onChange={(e) => {handleChange({ target: { name: "fromDate", value: e } })}}
              error={errors["fromDate"] ? true : false}
              helperText={errors["fromDate"] ? errors.fromDate[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-4">
            <Inputs
              name="toDate"
              size="small"
              label="End Date"
              value={formValues.toDate}
              inputType="date"
              onChange={(e) => {handleChange({ target: { name: "toDate", value: e } })}}
              error={errors["toDate"] ? true : false}
              helperText={errors["toDate"] ? errors.toDate[0] : null}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-4">
          <button style={{padding:"15px", borderRadius:"5px"}} onClick={(e)=>{e.preventDefault(); handleSearchSales()}}>
            Fetch Data
          </button>
          </div>
        </div>
      </>
    )
  }


  return (
    <div>
      <div className="ez-page-action">
        <h2 className="page-header">{instCat() === 4 ? 'Transactions' : 'Sales'}</h2>
        &nbsp;
         <div style={{alignContent:"right",paddingTop:"5px"}}>
          <button style={{padding:"5px", borderRadius:"5px"}}>
            <Link to={"/pos"} key={1} style={{color:"#fff"}}>
              {instCat() === 4 ? "New Transaction" : "New Sale"}
            </Link>
          </button>
        &nbsp;
        </div>
       
      </div>

      {
        formOpenSalesSearch()
      }

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              {status != 'loading' && salesDataList.length>0 ? (
                <Table
                  columns={salesTableHead}
                  data={salesDataList}
                  actions={[
                    {
                      action: "Details",
                      renderCheck: isDetailsAccess,
                      onClick: (item) => {
                       if(instCat() != 4 ) viewItem(item);
                      },
                    },
                    {
                      action: "Reverse",
                      onClick: (item) => {
                        handleReverse(item);
                      },
                    },
                  ]}
                  downloadFileName={"Sales List"}
                />
              ) : status === 'loading' ? (
                <MySpinner size={35} color="#367588" />
              ) : (<></>)}
            </div>
          </div>
        </div>
      </div>
      <MyDialog
        title={"Sale Receipt"}
        width="md"
        onClose={handleRequestClose}
        open={openDetail}
        text={"Sale Receipt"}
        content={() => dialogOpen()}
        //hideSaveButton={showSideEffect ? false: true}
        //propBackgroundColor="#367588"
      />

      <MyDialog
        title={"Reversing Sale Entry ?"}
        width="sm"
        onClose={handleRequestClose}
        open={openForm}
        text={"Reverse Entry"}
        content={() => reverseDialogOpen()}
        submit={(e)=> {handleSubmit(e)}}
        hideSaveButton={hideSaveButton}
        propBackgroundColor="#883636"
      />
    </div>
  );
};

export default Sales;
